import { setOptions } from '@googlemaps/js-api-loader';

const configuredKeys = new WeakMap();

/** The storefront and admin editor share one Google loader per browser page. */
export function configureGoogleMapsOptions(options, configure = setOptions) {
    const activeKey = configuredKeys.get(configure);
    if (activeKey !== undefined && activeKey !== options.key) {
        throw new Error(
            'A different Google Maps browser key is already active.',
        );
    }
    if (activeKey === undefined) {
        configure(options);
        configuredKeys.set(configure, options.key);
    }
}
